// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b7ec0cb7","455":"53f72b90","977":"286e7802"}[chunkId] + ".chunk.js";
};